/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AttributeOption {
  absFreq?: number;
  active?: boolean;
  attributeId?: number;
  attributeOptionId?: number;
  attributeOptionImage?: string;
  attributeOptionName?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  feedbackOptionIdNew?: number;
  feedbackOptionIdOld?: number;
  nextQuestionId?: number;
  order?: number;
  relFreq?: number;
  singleOption?: boolean;
}
